import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom"; 
import { 
  FiHome, 
  FiPackage, 
  FiShoppingCart, 
  FiUsers, 
  FiGift, 
  FiCreditCard, 
  FiSliders, 
  FiList, 
  FiMessageCircle, 
  FiCheckCircle, 
  FiTruck , FiClock, FiXCircle, FiBarChart2, FiBox, FiTag, FiDollarSign, FiVideo, FiAlertCircle,
  FiTrendingUp, FiUserCheck, FiUser, FiMessageSquare, FiMapPin, FiRotateCcw, FiMap, FiFileText, 
  FiFile, FiClipboard, FiShoppingBag, FiHelpCircle, FiPercent, FiActivity
} from "react-icons/fi";
import { BiLogOut, BiUser } from "react-icons/bi";


import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";


function Sidebar() {
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState(null);


    const navigate = useNavigate();

  // --- SECURITY CHECK: Redirect if not logged in ---
useEffect(() => {
  const vendorId = localStorage.getItem("vendorId");
  if (!vendorId) {
    navigate("/");
  }
}, [navigate]);


const handleLogout = (e) => {
  e.preventDefault(); // Prevent default navigation

  Swal.fire({
    title: "Logout?",
    text: "Are you sure you want to exit the admin panel?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, Logout!",
    cancelButtonText: "Cancel"
  }).then((result) => {
    if (result.isConfirmed) {
      // 1. Remove specific admin keys
      localStorage.removeItem("vendorId"); 

      // 2. Optional: Show success toast before redirecting
      Swal.fire({
        icon: "success",
        title: "Logged Out",
        text: "Redirecting to login...",
        timer: 1500,
        showConfirmButton: false
      });

      // 3. Navigate to root/login
      setTimeout(() => {
        navigate("/");
      }, 1500);
    }
  });
};





  // Map submenu routes to parent menu
  const menuMapping = {
    productDelivery: ["/product-list", "/product-create", "/delivery-cost"],
    orders: ["/all-orders", "/pending-orders", "/shipped-orders", "/delivered-orders", "/cancelled-orders", "/order-reports"],
    salesReports: ["/report-product-sales", "/report-category-sales"],
    paymentReports: ["/report-payment-summary", "/report-payouts", "/report-commissions", "/report-refunds"],
    inventoryReports: ["/report-stock", "/report-out-of-stock", "/report-product-performance"],
    customerReports: ["/report-top-customers", "/report-customer-history", "/report-customer-reviews"],
    shippingReports: ["/report-delivery-time", "/report-courier", "/report-returns"],
    analyticsReports: ["/report-sales-trends", "/report-geo-sales", "/report-growth"],
    taxReports: ["/report-tax", "/report-invoices", "/report-tcs"],
    customReports: ["/report-coupon-usage", "/report-abandoned-carts", "/report-support-tickets"]
  };

  useEffect(() => {
    // Auto-open parent menu if current path is in any submenu
    const activeMenu = Object.keys(menuMapping).find((menu) =>
      menuMapping[menu].includes(location.pathname)
    );
    setOpenMenu(activeMenu || null);
  }, [location.pathname]);

  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  return (
    <aside className="sidebar-wrapper">
      <div className="sidebar-header">
        {/* <div className="logo-icon">
          <img src="images/logo.jpg" className="logo-img" alt="Logo" />
        </div> */}
        <div className="logo-name flex-grow-1">
          <h5 className="mb-0">Vendor</h5>
        </div>
        <div className="sidebar-close">
          <span className="material-icons-outlined">close</span>
        </div>
      </div>

      <div className="sidebar-nav">
        <ul className="sidenav">

          {/* Dashboard */}
          <li>
            <Link to="/dashboard" className={location.pathname === "/dashboard" ? "active" : ""}>
              <div className="parent-icon"><FiHome size={20} /></div>
              <div className="menu-title">Dashboard</div>
            </Link>
          </li>

          {/* Product & Delivery */}
          <li className={`dropdown ${openMenu === "productDelivery" ? "open" : ""}`}>
            <button className="dropdown-toggle" onClick={() => toggleMenu("productDelivery")}>
              <div className="parent-icon"><FiPackage size={20} /></div>
              <div className="menu-title">Product & Delivery</div>
              <span className="material-icons-outlined arrow">{openMenu === "productDelivery" ? "expand_less" : "expand_more"}</span>
            </button>
            <ul className="submenu">
              <li>
                <Link to="/product-list" className={location.pathname === "/product-list" ? "active" : ""}>
                  <FiCheckCircle size={16} className="me-2" /> All Product
                </Link>
              </li>
              <li>
                <Link to="/product-create" className={location.pathname === "/product-create" ? "active" : ""}>
                  <FiCheckCircle size={16} className="me-2" /> Create Product
                </Link>
              </li>

              {/* <li>
                <Link to="/delivery-cost" className={location.pathname === "/delivery-cost" ? "active" : ""}>
                  <FiTruck size={16} className="me-2" /> Delivery Cost
                </Link>
              </li> */}
            </ul>
          </li>

          {/* Order Management */}
          <li className={`dropdown ${openMenu === "orders" ? "open" : ""}`}>
            <button className="dropdown-toggle" onClick={() => toggleMenu("orders")}>
              <div className="parent-icon"><FiShoppingCart size={20} /></div>
              <div className="menu-title">Order Management</div>
              <span className="material-icons-outlined arrow">{openMenu === "orders" ? "expand_less" : "expand_more"}</span>
            </button>
            <ul className="submenu">
              <li>
                <Link to="/all-orders" className={location.pathname === "/all-orders" ? "active" : ""}>
                  <FiList size={16} className="me-2" /> All Orders
                </Link>
              </li>
              <li>
                <Link to="/pending-orders" className={location.pathname === "/pending-orders" ? "active" : ""}>
                  <FiClock size={16} className="me-2" /> Pending Orders
                </Link>
              </li>
              <li>
                <Link to="/shipped-orders" className={location.pathname === "/shipped-orders" ? "active" : ""}>
                  <FiTruck size={16} className="me-2" /> Shipped Orders
                </Link>
              </li>
              <li>
                <Link to="/delivered-orders" className={location.pathname === "/delivered-orders" ? "active" : ""}>
                  <FiCheckCircle size={16} className="me-2" /> Delivered Orders
                </Link>
              </li>
              <li>
                <Link to="/cancelled-orders" className={location.pathname === "/cancelled-orders" ? "active" : ""}>
                  <FiXCircle size={16} className="me-2" /> Cancelled Orders
                </Link>
              </li>
              <li>
                <Link to="/order-reports" className={location.pathname === "/order-reports" ? "active" : ""}>
                  <FiBarChart2 size={16} className="me-2" /> Order Reports
                </Link>
              </li>
            </ul>
          </li>

          {/* Sales & Orders */}
          <li className={`dropdown ${openMenu === "salesReports" ? "open" : ""}`}>
            <button className="dropdown-toggle" onClick={() => toggleMenu("salesReports")}>
              <div className="parent-icon"><FiShoppingCart size={20} /></div>
              <div className="menu-title">Sales & Orders</div>
              <span className="material-icons-outlined arrow">{openMenu === "salesReports" ? "expand_less" : "expand_more"}</span>
            </button>
            <ul className="submenu">
              <li>
                <Link to="/report-product-sales" className={location.pathname === "/report-product-sales" ? "active" : ""}>
                  <FiBox size={16} className="me-2" /> Product-wise Sales
                </Link>
              </li>
              <li>
                <Link to="/report-category-sales" className={location.pathname === "/report-category-sales" ? "active" : ""}>
                  <FiTag size={16} className="me-2" /> Category-wise Sales
                </Link>
              </li>
            </ul>
          </li>

          {/* Payments & Settlements */}
          <li className={`dropdown ${openMenu === "paymentReports" ? "open" : ""}`}>
            <button className="dropdown-toggle" onClick={() => toggleMenu("paymentReports")}>
              <div className="parent-icon"><FiCreditCard size={20} /></div>
              <div className="menu-title">Payments & Settlements</div>
              <span className="material-icons-outlined arrow">{openMenu === "paymentReports" ? "expand_less" : "expand_more"}</span>
            </button>
            <ul className="submenu">
              <li>
                <Link to="/report-payment-summary" className={location.pathname === "/report-payment-summary" ? "active" : ""}>
                  <FiDollarSign size={16} className="me-2" /> Payment Summary
                </Link>
              </li>

              <li>
                <Link to="/platform-charge" className={location.pathname === "/platform-charge" ? "active" : ""}>
                  <FiDollarSign size={16} className="me-2" /> Platform Charges
                </Link>
              </li>


              


              {/* <li>
                <Link to="/report-payouts" className={location.pathname === "/report-payouts" ? "active" : ""}>
                  <FiDollarSign size={16} className="me-2" /> Payouts
                </Link>
              </li> */}
              {/* <li>
                <Link to="/report-commissions" className={location.pathname === "/report-commissions" ? "active" : ""}>
                  <FiPercent size={16} className="me-2" /> Commissions
                </Link>
              </li> */}
              {/* <li>
                <Link to="/report-refunds" className={location.pathname === "/report-refunds" ? "active" : ""}>
                  <FiRotateCcw size={16} className="me-2" /> Refunds & Chargebacks
                </Link>
              </li> */}
            </ul>
          </li>

          {/* Inventory Reports */}
          <li className={`dropdown ${openMenu === "inventoryReports" ? "open" : ""}`}>
            <button className="dropdown-toggle" onClick={() => toggleMenu("inventoryReports")}>
              <div className="parent-icon"><FiPackage size={20} /></div>
              <div className="menu-title">Inventory Reports</div>
              <span className="material-icons-outlined arrow">{openMenu === "inventoryReports" ? "expand_less" : "expand_more"}</span>
            </button>
            <ul className="submenu">
              <li>
                <Link to="/report-stock" className={location.pathname === "/report-stock" ? "active" : ""}>
                  <FiPackage size={16} className="me-2" /> Stock Report
                </Link>
              </li>
              {/* <li>
                <Link to="/report-out-of-stock" className={location.pathname === "/report-out-of-stock" ? "active" : ""}>
                  <FiAlertCircle size={16} className="me-2" /> Out of Stock
                </Link>
              </li> */}
              <li>
                <Link to="/report-product-performance" className={location.pathname === "/report-product-performance" ? "active" : ""}>
                  <FiTrendingUp size={16} className="me-2" /> Product Performance
                </Link>
              </li>
            </ul>
          </li>

          {/* Shipping & Returns */}
          <li className={`dropdown ${openMenu === "shippingReports" ? "open" : ""}`}>
            <button className="dropdown-toggle" onClick={() => toggleMenu("shippingReports")}>
              <div className="parent-icon"><FiTruck size={20} /></div>
              <div className="menu-title">Shipping & Returns</div>
              <span className="material-icons-outlined arrow">{openMenu === "shippingReports" ? "expand_less" : "expand_more"}</span>
            </button>
            <ul className="submenu">
              {/* <li>
                <Link to="/report-delivery-time" className={location.pathname === "/report-delivery-time" ? "active" : ""}>
                  <FiClock size={16} className="me-2" /> Delivery Time
                </Link>
              </li>
              <li>
                <Link to="/report-courier" className={location.pathname === "/report-courier" ? "active" : ""}>
                  <FiMapPin size={16} className="me-2" /> Courier Partner
                </Link>
              </li>
              <li>
                <Link to="/report-returns" className={location.pathname === "/report-returns" ? "active" : ""}>
                  <FiRotateCcw size={16} className="me-2" /> Return Orders
                </Link>
              </li> */}
            </ul>
          </li>

          {/* Analytics */}
          <li className={`dropdown ${openMenu === "analyticsReports" ? "open" : ""}`}>
            <button className="dropdown-toggle" onClick={() => toggleMenu("analyticsReports")}>
              <div className="parent-icon"><FiBarChart2 size={20} /></div>
              <div className="menu-title">Analytics</div>
              <span className="material-icons-outlined arrow">{openMenu === "analyticsReports" ? "expand_less" : "expand_more"}</span>
            </button>
            <ul className="submenu">
              <li>
                <Link to="/report-sales-trends" className={location.pathname === "/report-sales-trends" ? "active" : ""}>
                  <FiTrendingUp size={16} className="me-2" /> Sales Trends
                </Link>
              </li>
              {/* <li>
                <Link to="/report-geo-sales" className={location.pathname === "/report-geo-sales" ? "active" : ""}>
                  <FiMap size={16} className="me-2" /> Geographical Sales
                </Link>
              </li> */}
              <li>
                <Link to="/report-growth" className={location.pathname === "/report-growth" ? "active" : ""}>
                  <FiActivity size={16} className="me-2" /> Revenue Growth
                </Link>
              </li>
            </ul>
          </li>

          {/* Tickets & Support */}
          <li className={`dropdown ${openMenu === "customReports" ? "open" : ""}`}>
            <button className="dropdown-toggle" onClick={() => toggleMenu("customReports")}>
              <div className="parent-icon"><FiGift size={20} /></div>
              <div className="menu-title">Tickets & Support</div>
              <span className="material-icons-outlined arrow">{openMenu === "customReports" ? "expand_less" : "expand_more"}</span>
            </button>
            <ul className="submenu">
              {/* <li>
                <Link to="/report-coupon-usage" className={location.pathname === "/report-coupon-usage" ? "active" : ""}>
                  <FiGift size={16} className="me-2" /> Coupon Usage
                </Link>
              </li>
              <li>
                <Link to="/report-abandoned-carts" className={location.pathname === "/report-abandoned-carts" ? "active" : ""}>
                  <FiShoppingBag size={16} className="me-2" /> Abandoned Carts
                </Link>
              </li> */}
              <li>
                <Link to="/report-support-tickets" className={location.pathname === "/report-support-tickets" ? "active" : ""}>
                  <FiHelpCircle size={16} className="me-2" /> Support Tickets
                </Link>
              </li>
              <li>
                <Link to="/support/tickets" className={location.pathname === "/support/tickets" ? "active" : ""}>
                  <FiHelpCircle size={16} className="me-2" />All Support Tickets
                </Link>
              </li>
            </ul>
          </li>


           <li>
            <Link to="/profile" className={location.pathname === "/profile" ? "active" : ""}>
              <div className="parent-icon"><BiUser size={20} /></div>
              <div className="menu-title">Profile</div>
            </Link>
          </li>


<hr/>
<li>
  <a 
    href="#logout" 
    onClick={handleLogout}  
    style={{ cursor: 'pointer' }}
  >
    <div className="parent-icon"><BiLogOut size={20} /></div>
    <div className="menu-title">Logout</div>
  </a>
</li>
        </ul>
      </div>
    </aside>
  );
}

export default Sidebar;
